// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumbs_wrapper__N50S_","list":"breadcrumbs_list__J0jup","listItem":"breadcrumbs_listItem__5sG6W"};